import signing from './letters-signing-zh'

/** 决定函（规划 P4-2a，设计 §6）：设置 → 规划 → 决定函。 */
export default {
  letters: {
    signing,
    settings: {
      title: '决定函',
      description: '允许官员根据案件生成决定函。下方的信头会印在每封函件的顶部，签署人是可以签署函件的人员。',
      enabled: '在案件上提供决定函',
      enabledHint:
        '默认关闭。只有官员在作出决定后提出要求，才会生成函件。目前提供的函件模板是临时模板：未经法律审查，也未经任何市政局确认，其 PDF 带有 DRAF 标记。',
      requireSignature: '函件必须先签署才能共享',
      requireSignatureOn: '只有已签署的函件才能与申请人共享。没有信任锚时，每封已签署的函件都要等官员明确共享。',
      requireSignatureOff: '生成的函件签发后即可与申请人共享，无需签署。',
      councilMs: '议会名称（马来语）',
      councilEn: '议会名称（英语，可选）',
      councilEnHint: '仅在有官方英文来源时使用。函件以马来语撰写。',
      addressLines: '地址',
      addressLinesHint: '每行一条，最多五行。',
      phone: '电话',
      email: '电子邮件',
      website: '网站',
      footer: '页脚',
      logo: '议会标志',
      logoHint: 'PNG 或 JPEG 文件，不超过 256 KiB，每边不超过 2048 像素。不接受 CMYK 的 JPEG。',
      logoRemove: '移除标志',
      logoType: '请选择 PNG 或 JPEG 文件。',
      logoSize: '标志不能超过 256 KiB。',
      logoAlt: '议会标志',
      signatories: '签署人',
      signatoriesHint: '最多十人。官员在准备函件时从中选择一人。',
      signatoryNone: '尚无签署人。',
      signatoryName: '姓名',
      signatoryTitle: '职务',
      signatoryAdd: '添加签署人',
      signatoryRemove: '移除',
      previewTitle: '信头预览',
      previewNote: '此处仅显示函件所带的信头，并非函件本身。',
      previewEmpty: '填写信头后即可在此查看。',
      save: '保存函件设置',
      saving: '正在保存…',
      saved: '函件设置已保存。',
      problems: {
        tooLong: '内容过长。',
        addressLinesTooMany: '地址最多使用五行。',
        emailInvalid: '请输入一个电子邮件地址。',
        websiteInvalid: '请输入以 http:// 或 https:// 开头的地址。',
        signatoriesTooMany: '签署人最多十人。',
        signatoryIncomplete: '每位签署人都需要姓名和职务。',
      },
      trustAnchors: {
        title: '信任锚',
        hint: '本议会信任的证书颁发机构，采用 PEM 格式，最多十个。已签署函件的证书链只会对照此列表检查。目前尚未检查证书吊销；使用 gisify 无法执行的约束的证书链会被视为不受信任。',
        none: '尚无信任锚。',
        addFile: '添加证书文件',
        paste: '或粘贴证书',
        pasteAdd: '添加粘贴的证书',
        remove: '移除 {{name}}',
        unnamed: '没有通用名称的证书',
        unread: '尚未读取。保存时会进行检查。',
        fingerprint: 'SHA-256 指纹 {{sha256}}',
        validUntil: '有效期至 {{date}}',
        expired: '已于 {{date}} 过期。只能追溯到此信任锚的签署人会被视为不受信任。',
        notPem: '这不是一份 PEM 证书。证书必须以 BEGIN CERTIFICATE 开头，并以 END CERTIFICATE 结尾。',
        tooLarge: '证书不能超过 16 KiB。',
        tooMany: '信任锚最多十个。',
        duplicate: '该证书已在列表中。',
        readFailed: '无法读取该文件。',
      },
    },
    panel: {
      title: '决定函',
      intro: '根据本案的某项决定生成决定函。函件在官员签发之前一直是草稿；签发后会保存在案件中。',
      offers: '可准备的函件',
      noOffers: '本案暂无可提供的函件。',
      offerFor: '针对第 {{seq}} 步的决定',
      prepare: '准备',
      provisional: '临时模板：未经法律审查，也未经任何市政局确认。PDF 带有 DRAF 标记。',
      listTitle: '本案的函件',
      none: '尚未准备任何函件。',
      newest: '该决定的最新函件',
      forDecision: '第 {{seq}} 步的决定',
      shared: '已与申请人共享',
      notShared: '未共享',
      openDraft: '打开草稿',
      issue: '签发',
      discard: '丢弃',
      share: '与申请人共享',
      hide: '对申请人隐藏',
      rendering: '正在生成函件…',
      renderingSlow: '耗时比预期长。请稍后再查看。',
      retry: '再次查看',
      failed: '无法生成函件（{{code}}）。',
      failedGlyph: '无法生成函件：{{field}}含有函件字体中没有的字符。请更正后重新准备函件，或将函件作为文件上传。',
      failedGlyphTemplate: '无法生成函件：{{field}}含有函件字体中没有的字符。请告知管理员，并暂时将函件作为文件上传。',
      field: {
        applicantName: '申请人姓名',
        applicantFirm: '申请人公司',
        caseReference: '案件编号',
        decisionNumber: '决定编号',
        decisionDate: '决定日期',
        councilName: '信头上的市议会名称',
        letterheadAddress: '信头地址',
        letterheadContact: '信头联系方式',
        letterheadFooter: '信头页脚',
        signatoryName: '签署人姓名',
        signatoryTitle: '签署人职衔',
        read: '决定值“{{alias}}”',
        blockLabel: '函件模板第 {{n}} 部分的标签',
        blockText: '函件模板第 {{n}} 部分的文字',
        unknown: '函件的某一部分',
      },
      signatureRequired: '请下载已签发的函件，用您自己的工具签署，然后在此上传。',
      downloadIssued: '下载已签发的函件',
      downloadSigned: '下载已签署的函件',
      uploadSigned: '上传已签署的函件',
      uploadSignedAgain: '重新上传已签署的函件',
      uploading: '正在上传已签署的函件… {{percent}}%',
      uploadFinalizing: '正在检查上传的文件…',
      verifying: '正在检查签名…',
      signedShared: '已共享',
      signedSharedAuto: '已自动共享',
      issuedStillShown: '申请人目前仍看到已签发的函件。共享已签署的函件后将取而代之。',
      ordinaryFallback: '该文件仍可作为普通文件上传，但不会与任何内容关联。',
      noOrdinaryFallback: '案件处于此阶段时，该文件不能另行保存。请重新签署已签发的文件并上传。',
      signed: {
        kind: { pades: '签名类型：PAdES', not_pades: '签名类型：非 PAdES 的 PDF 签名' },
        chain: {
          trusted: '证书：可追溯到为本议会配置的证书颁发机构',
          untrusted: '证书：无法追溯到已配置的证书颁发机构',
          unchecked: '证书：未对照任何证书颁发机构检查',
        },
        signer: '签署者：{{name}}',
        signerUnknown: '签署者：未记录',
        issuer: '颁发者：{{name}}',
        serial: '序列号：{{serial}}',
        validity: '有效期自 {{from}} 至 {{to}}',
        fingerprint: 'SHA-256 指纹：{{sha256}}',
        signingTime: '签署时间（由签署者自己的工具声明）：{{date}}',
        signatory: {
          match: '签署人：证书上的姓名与所选签署人相符',
          mismatch: '签署人：证书上的姓名与所选签署人不符',
          not_comparable: '签署人：无法将此证书与所选签署人比较',
        },
        stamp: '签章：第 {{page}} 页，占页面的 {{percent}}%',
        noStamp: '没有可见的签章',
        noRevocation: '未检查该证书是否已被吊销。',
        limit: 'gisify 已检查已签发函件的页面内容未被改写；它没有渲染该文件，而签名签章可能遮盖其方框内的文字。',
      },
      warning: {
        chain_unchecked: '未配置信任锚，因此未对照任何证书颁发机构检查此证书。自签名证书也会走到这一步。',
        chain_untrusted: '此证书无法追溯到已配置的证书颁发机构，或其证书链无法解读。这本身并不表示证书无效。',
        signatory_mismatch: '此证书上的姓名与所选签署人不符。请确认签署者是否正确。',
        signatory_not_comparable: '无法将此证书与所选签署人比较。请确认签署者是否正确。',
        signer_ic_number: '此证书含有看似身份证号码的内容。共享此函件会向申请人披露该号码。',
        signature_stamp_large:
          '签名签章遮盖了第 {{page}} 页的 {{percent}}%。共享前请打开已签署的函件，确认它没有遮盖任何内容。',
        decision_superseded: '更新的决定已取代此函件所依据的决定。',
        letter_superseded: '此决定已签发更新的函件。此副本属于较旧的函件，其内容可能已过时。',
      },
      refusal: {
        signed_letter_not_derived: '此文件不是在已签发函件上添加签名而成的。',
        signed_letter_overrides_content: '此文件对函件的改动超出了签名所需的范围。',
        signed_letter_unsupported_structure:
          '无法检查此文件的结构。如果签名的原因或签章中含有 xref、startxref 或 trailer 这些词，请不带这些词重新签署已签发的文件。',
        signature_invalid: '此文件中的签名未通过验证。文件可能在签署后被更改。',
        signature_algorithm_refused:
          '此签名使用了 gisify 不接受的算法或密钥长度。请换用其他算法或密钥重新签署已签发的文件。',
        stage_held_externally: '本案目前由另一系统持有，因此未接受已签署的函件。',
        stage_locked: '本案不再接受已签署的函件。',
        too_large: '此文件超过了已签署函件的大小限制。',
        upload_missing: '找不到已上传的文件。请重新上传。',
        issued_letter_unreadable: '无法读取已签发的函件以与此文件比较。请重试；如果再次发生，请告知管理员。',
        verify_timeout: '检查耗时过长，已被停止。请重新上传文件。',
        dispatch_failed: '无法启动检查。请重新上传文件。',
        unknown: '无法接受此文件。请重新签署已签发的文件并上传。',
      },
      uploadRefused: {
        too_large: '已签署的函件被拒绝：文件超过了已签署函件的大小限制。',
        empty: '已签署的函件被拒绝：文件是空的。',
        unsupported_type: '已签署的函件被拒绝：文件不是 PDF。',
        missing: '已签署的函件被拒绝：文件未到达服务器。请重新上传。',
        size_mismatch: '已签署的函件被拒绝：收到的文件大小与发送的大小不一致。请重新上传。',
        unreadable: '已签署的函件被拒绝：无法读取收到的文件。请重新上传。',
        unknown: '已签署的函件被拒绝。请重新上传文件。',
      },
      shareDialog: {
        title: '共享已签署的函件',
        intro: '申请人将看到已签署的函件，取代已签发的函件。共享前请阅读每条警告。',
        none: '此签名没有任何警告。',
        confirmIc: '我确认此函件会向申请人披露签署者的身份证号码。',
        submit: '共享',
        issued: {
          title: '共享已签发的函件',
          intro: '申请人将看到这份已签发的函件。共享前请阅读每条警告。',
          none: '此函件没有任何警告。',
        },
      },
      warnCommunicated: '该决定记录的通知日期早于今天。现在共享不会更改该日期。',
      loadFailed: '无法加载函件。',
      status: {
        rendering: '正在生成',
        draft: '草稿',
        failed: '失败',
        issued: '已签发',
        discarded: '已丢弃',
        expired: '已过期',
      },
      held: {
        title: '等待函件的决定邮件',
        body: '函件共享后，申请人才会收到该决定的邮件。您可以不等待而立即发送该邮件。',
        item: '第 {{seq}} 步的决定',
        release: '立即发送邮件',
        released: '邮件即将发送。',
      },
      dialog: {
        title: '准备决定函',
        template: '函件：{{template}}',
        signatory: '签署人',
        pick: '选择签署人',
        none: '尚无签署人。管理员可在“设置 → 规划”中添加。',
        submit: '准备函件',
        cancel: '取消',
        note: '函件根据该决定生成，并保存为草稿供您打开。',
      },
    },
  },
  errors: {
    letters_off: '决定函已关闭。管理员可在“设置 → 规划”中开启。',
    template_not_offered: '本申请不提供该函件。',
    letterhead_incomplete: '信头尚不完整。管理员可在“设置 → 规划”中补全。',
    letter_value_missing: '本申请缺少该函件所需的内容。',
    letter_not_found: '在本申请中找不到该函件。',
    letter_not_draft: '该函件已不再是草稿。请重新加载案件后再试。',
    letter_not_issued: '该函件尚未签发。',
    letter_draft_stale:
      '更新的决定已取代该草稿所依据的决定，因此该草稿不能签发。如果该函件仍列在“可准备的函件”下，请重新准备。如果未列出，则本申请已不能再准备该函件。',
    letter_draft_changed: '已存储的草稿并非生成的那一份。请重新准备函件。',
    signature_required: '函件必须先签署才能共享。',
    signatory_unknown: '该签署人不在信头上。',
    invalid_letter_request: '该函件请求无效。',
    held_email_not_found: '该步骤没有等待函件的决定邮件。',
    letter_imported: '该函件来自另一系统，因此不能在此签署。',
    letter_signature_verifying: '该函件的已签署副本仍在检查中。请等待结果。',
    letter_already_signed: '该函件已有通过验证的已签署副本。',
    letter_not_verifying: '该已签署副本已不在检查中。请重新加载案件。',
    signature_warning_unacknowledged: '共享函件前必须确认每条警告。',
  },
}
